<template>
  <bx-box variant="gray" class="accident-involved">
    <bx-box variant="white">
      <b-row class="p-2">
        <b-col md="6">
          <b-form-group :label="$t('common.firstname')">
            <b-input type="text" v-model="value.firstname" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :label="$t('common.lastname')">
            <b-input type="text" v-model="value.lastname" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group :label="$t('common.phone')">
            <b-input type="text" v-model="value.phone" />
          </b-form-group>
        </b-col>
        <b-col md="9">
          <b-form-group :label="$t('common.email')">
            <b-input type="text" v-model="value.email" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="
              $t('formular.employee.accidentreport.accident_involved.domicile')
            "
          >
            <b-input type="text" v-model="value.location" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="
              $t('formular.employee.accidentreport.accident_involved.location')
            "
          >
            <b-input type="text" v-model="value.street" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group
            :label="
              $t('formular.employee.accidentreport.accident_involved.plate')
            "
          >
            <b-input type="text" v-model="value.plate" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            :label="
              $t('formular.employee.accidentreport.accident_involved.brand')
            "
          >
            <b-input type="text" v-model="value.brand" />
          </b-form-group>
        </b-col>
        <b-col md="5">
          <b-form-group
            :label="
              $t(
                'formular.employee.accidentreport.accident_involved.insurance_name'
              )
            "
          >
            <b-input type="text" v-model="value.insurance" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="
              $t(
                'formular.employee.accidentreport.accident_involved.insurance_number'
              )
            "
          >
            <b-input type="text" v-model="value.insurance_number" />
          </b-form-group>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button variant="danger" class="mt-5" @click="$emit('delete')"
            ><i class="ifr if-trash mr-2" />{{ $t("actions.delete") }}</b-button
          >
        </b-col>
      </b-row>
    </bx-box>
  </bx-box>
</template>

<script>
  export default {
    name: "Accidentinvolved",
    props: {
      value: {
        type: Object,
        default: () => {
          return {
            id: null,
            firstname: null,
            lastname: null,
            plate: null,
            phone: null,
            email: null,
            brand: null,
            insurance: null,
            insurance_number: null,
            location: null,
            location1: null,
            street: null,
          };
        },
      },
    },
    watch: {
      value: {
        deep: true,
        handler: function () {
          this.$emit("input", this.value);
        },
      },
    },
  };
</script>

<style lange="scss" scoped>
  .accident-involved {
    margin-bottom: 1rem;
  }
</style>
